export { createSearchClient } from './client'
export type { SearchClient } from './client'

export { createProductIndex } from './product-index'
export type { ProductIndex } from './product-index'

export { buildIndexName } from './index-name'
export type { IndexNameOptions } from './index-name'

export { getProductId, getProductVariants } from './product-hit'
export type { ProductHit, ProductHitVariant } from './product-hit'

export {
  configureAccessKey,
  fetchAccessKey,
  clearAccessKey,
  getCachedAccessKey,
  resolveProductIndexName,
  registerSecuredClient,
  unregisterSecuredClient,
} from './access-key'
export type {
  AlgoliaAccessKey,
  FetchAccessKeyParams,
  SecuredKeyProvider,
  AccessKeyConfig,
} from './access-key'

export type { LiteClient, SearchParamsObject, SearchResponse } from 'algoliasearch/lite'
